import {RigidBody, useRapier} from '@react-three/rapier'
import { useFrame } from '@react-three/fiber'
import { useRef } from 'react'
import {useKeyboardControls} from '@react-three/drei'
import { useEffect } from 'react'
import * as THREE from 'three'
import { useState } from 'react'
import { useContext } from 'react'
import { GeometryContext } from '../store/store'
import { useDispatch, useSelector } from 'react-redux'
import interfaceSlice from '../store/interfaceSlice'

const Player = () => {
    const body = useRef()
    const [subscribeKeys, getKeys] = useKeyboardControls()
    const {rapier, world} = useRapier()
    const rapierWorld = world.raw()
    const [smoothCameraPosition] = useState(()=> new THREE.Vector3(10,10,10))
    const [smoothCameraTarget] = useState(()=>new THREE.Vector3())
    const storeCtx = useContext(GeometryContext)
    const {interface:interfaceState}  = useSelector((state)=>state)
    const {onStart, onEnd, onRestart} = interfaceSlice.actions
    const dispatch = useDispatch()
    // console.log(dispatch)
    useEffect(()=>{
        const phaseHandler = () =>{
            if(interfaceState.phase === 'ready'){
                reset()
            }
        }
        phaseHandler()
        
    },[interfaceState.phase])


    const jump = () =>{
        const origin = body.current.translation()
        origin.y -= 0.31
        const direction = {x:0, y: -1, z:0}
        const ray = new rapier.Ray(origin, direction)
        const hit = rapierWorld.castRay(ray,10, true)

        if(hit.toi < 0.15){
            body.current.applyImpulse({x:0, y: 0.5, z:0})
        }
    }

    const reset = () =>{
        body.current.setTranslation({x:0, y:1, z:0})
        body.current.setLinvel({x:0,y:0,z:0})
        body.current.setAngvel({x:0,y:0,z:0})
    }

    useEffect(()=>{;
        const unsubscribeJump = subscribeKeys((state)=>{
            return state.jump
        },(value)=>{
           if(value){
                jump()
           }
        })
        
        const unsubscribeAny = subscribeKeys(()=>{
            // storeCtx.onStart()
            dispatch(onStart())
        })
        return ()=>{
            unsubscribeJump()
            unsubscribeAny()
        }
    },[dispatch])

    useFrame((state, delta)=>{

        /**
         * Controls
         */
        const {forward, backward, leftward, rightward} = getKeys()
        
        const impulse = {x: 0, y: 0, z: 0}
        const torque = {x: 0, y: 0, z: 0}

        const impulseStrength = 0.6 * delta
        const torqueStrength = 0.2 * delta

        if(forward){
            // storeCtx.onStart()
            dispatch(onStart())
            impulse.z -= impulseStrength
            torque.x -= torqueStrength
        }
        if(backward){
            impulse.z += impulseStrength
            torque.x += torqueStrength
        }
        if(leftward){
            impulse.x -= impulseStrength
            torque.z += torqueStrength
        }
        if(rightward){
            impulse.x += impulseStrength
            torque.z -= torqueStrength
        }

        body.current.applyImpulse(impulse)
        body.current.applyTorqueImpulse(torque)

        /**
         * Camera
         */
        const bodyPostion = body.current.translation()
        const cameraPosition = new THREE.Vector3()
        cameraPosition.copy(bodyPostion)
        cameraPosition.z += 2.25
        cameraPosition.y += 0.65

        const cameraTarget = new THREE.Vector3()
        cameraTarget.copy(bodyPostion)
        cameraTarget.y += 0.25

        smoothCameraPosition.lerp(cameraPosition, 5 * delta)
        smoothCameraTarget.lerp(cameraTarget, 5 * delta)


        state.camera.position.copy(smoothCameraPosition)
        state.camera.lookAt(smoothCameraTarget)


        /**
         * Game Mechanics - Phases
         */
        if(bodyPostion.z < -(interfaceState.blocksCount * 4 + 2)){
            // storeCtx.onEnd()
            dispatch(onEnd())
        }

        if(bodyPostion.y < -4){
            // storeCtx.onRestart()
            dispatch(onRestart())
        }
    })

    return (
        <RigidBody 
            position={[0,1,0]} 
            colliders='ball' 
            restitution={0.2} 
            friction={1} 
            linearDamping={0.5}
            angularDamping={0.5}
            ref={body}
        >
            <mesh castShadow>
                <icosahedronGeometry args={[0.3,1]}/>
                <meshStandardMaterial color='mediumpurple' flatShading/>
            </mesh>
        </RigidBody>
    )
}

export default Player